import React from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../../hooks/useAuth';
import Home from '../../pages/Admin/Home';
import MyLoans from '../../pages/Admin/MyLoans';
import Fgts from '../../pages/Admin/Fgts';
import CreatePartner from '../../pages/Admin/CreatePartner';
import MyData from '../../pages/Admin/MyData';
import IndexFgts from '../../pages/Admin/Fgts/IndexFgts';
import Create from '../../pages/Admin/Fgts/Create';
import CreateCartao from '../../pages/Admin/Fgts/CreateCartao';
import CreatePay from '../../pages/Admin/Fgts/Create-pay';
import ServiceChannel from '../../pages/Admin/ServiceChannel';
import Balance from '../../pages/Admin/Fgts/Balance';
import BalanceCartao from '../../pages/Admin/Fgts/BalanceCartao';
import Simulation from '../../pages/Admin/Fgts/Simulation';
import SimulationCartao from '../../pages/Admin/Fgts/SimulationCartao';
import CustomerData from '../../pages/Admin/Fgts/CustomerData';
import CustomerDataCartao from '../../pages/Admin/Fgts/CustomerDataCartao';
import Concluded from '../../pages/Admin/Fgts/Concluded';
import ConcludedCartao from '../../pages/Admin/Fgts/ConcludedCartao';
import DigitalAuthorization from '../../pages/Admin/Fgts/DigitalAuthorization';
import DigitalAuthorizationCartao from '../../pages/Admin/Fgts/DigitalAuthorizationCartao';
import EditUser from '../../pages/Admin/Users';

const PrivateRouteAdmin = ({ element }) => {
    const { loading, authenticated, user } = useAuth();
    const isAdmin = user?.role === 'ADMIN';
    if (loading) return <h1>Loading...</h1>;
    
    return authenticated  ? element : <Navigate to="/signin" />;
};

const PrivateRouteUser = ({ element }) => {
    const { loading, authenticated, user } = useAuth();
    const isUser = user?.role === 'USER';
    if (loading) return <h1>Loading...</h1>;

    return authenticated  ? element : <Navigate to="/signin" />;
};

const privateRoutes = [
    { path: '/admin/home', element: <PrivateRouteUser element={<Home />} /> },
    { path: '/admin/my-loans', element: <PrivateRouteUser element={<MyLoans />} /> },
    { path: '/admin/saque-aniversario-fgts', element: <PrivateRouteAdmin element={<Fgts />} /> },
    { path: '/admin/service-channel', element: <PrivateRouteAdmin element={<ServiceChannel />} /> },
    { path: '/admin/create-partner', element: <PrivateRouteAdmin element={<CreatePartner />} /> },
    { path: '/admin/user-manangement', element: <PrivateRouteAdmin element={<EditUser />} /> },
    { path: '/admin/my-data', element: <PrivateRouteUser element={<MyData />} /> },
    { path: '/admin/fgts/index', element: <PrivateRouteAdmin element={<IndexFgts />} /> },
    { path: '/admin/fgts/create', element: <PrivateRouteAdmin element={<Create />} /> },
    { path: '/admin/fgts/create-cartao', element: <PrivateRouteAdmin element={<CreateCartao />} /> },
    { path: '/admin/fgts/create-pay', element: <PrivateRouteAdmin element={<CreatePay />} /> },
    { path: '/admin/fgts/:proposalUuid/balance', element: <PrivateRouteAdmin element={<Balance />} /> },
    { path: '/admin/fgts/:proposalUuid/balance-cartao', element: <PrivateRouteAdmin element={<BalanceCartao />} /> },
    { path: '/admin/fgts/:proposalUuid/simulation', element: <PrivateRouteAdmin element={<Simulation />} /> },
    { path: '/admin/fgts/:proposalUuid/simulation-cartao', element: <PrivateRouteAdmin element={<SimulationCartao />} /> },
    { path: '/admin/fgts/:proposalUuid/customer-data', element: <PrivateRouteAdmin element={<CustomerData />} /> },
    { path: '/admin/fgts/:proposalUuid/customer-data-cartao', element: <PrivateRouteAdmin element={<CustomerDataCartao />} /> },
    { path: '/admin/fgts/:proposalUuid/concluded', element: <PrivateRouteAdmin element={<Concluded integrationName />} /> },
    { path: '/admin/fgts/:proposalUuid/concluded-cartao', element: <PrivateRouteAdmin element={<ConcludedCartao integrationName />} /> },
    { path: '/admin/fgts/:proposalUuid/digital-authorization', element: <PrivateRouteAdmin element={<DigitalAuthorization />} /> },
    { path: '/admin/fgts/:proposalUuid/digital-authorization-cartao', element: <PrivateRouteAdmin element={<DigitalAuthorizationCartao />} /> },
];

export default privateRoutes;